import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import "./wizard-step.scss";

const WizardStep = ({
  component: ChildComponent,
  className,
  isStepComplete,
  ...rest
}) => (
  <div className={cn("wizard-step", className)}>
    <ChildComponent {...rest} />
  </div>
);

WizardStep.propTypes = {
  isStepComplete: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default WizardStep;
